import emoji from 'react-easy-emoji';
import ecoSoftLogo from './assets/img/ecosoft.jpeg';
/* eslint-disable import/prefer-default-export */
export const greetings = {
  name: 'Yeasin Hossain',
  title: "Hi all, I'm Yeasin",
  description:
    'I’m a full-stack developer, I work for mobile and web applications. I enjoy working with a team as a leader or member. I love to develop real-time(socket.io) applications using javascript(ES6, React, React-Native, Next). Nodejs is an incredible backend technology, and I’m always familiar with this.',
  resumeLink: 'https://drive.google.com/file/d/1Cu5FWBF3NirDSde7tEk2F7qJdXUgajsA/view?usp=sharing',
  resumeDownload:
    'https://drive.google.com/uc?export=download&id=1Cu5FWBF3NirDSde7tEk2F7qJdXUgajsA',
};
export const socialLinks = {
  facebook: 'https://www.facebook.com/shantoxdp1',
  github: 'https://github.com/yeasin-hossain',
  linkedin: 'https://www.linkedin.com/in/yeasinxdp/',
};
export const skillsSection = {
  title: 'What I do',
  subTitle: 'CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK',
  skills: [
    emoji(
      '⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications'
    ),
    emoji('⚡ Progressive Web Applications ( PWA ) in normal and SPA Stacks'),
    emoji('⚡ Integration of third party services such as Firebase/ AWS / Digital Ocean'),
  ],
};

export const projects = [
  {
    id: 4,
    type: 'Mobile',
    screenshot: 'https://i.ibb.co/s9cPv5f/Screenshot-1.png',
    name: 'Smarter Stock',
    technologies: [
      'React',
      'Ionic',
      'Capacitor',
      'Trading View',
      'Chart',
      'Candle stick',
      'Market depth',
    ],
    desc: 'Smarter Stock is the revolutionary Technical & Fundamental analysis software for Dhaka Stock Exchange (DSE) & Chittagong Stock Exchange (CSE)',
    live: 'https://play.google.com/store/apps/details?id=com.ecosoftbd.smarterstock&hl=en&gl=US',
    github: '',
  },
  {
    id: 1,
    type: 'fullStack',
    screenshot: 'https://i.ibb.co/87W5QVk/img.png',
    name: 'Grow Food Catering',
    technologies: ['React', 'Bootstrap', 'Express', 'JWT', 'Bcrypt', 'Heroku', 'Netlify'],
    desc: ' *users order food for a limited person specified the date, and pay with Stripe.*Only register users can order, and the dashboard will show order status.*Admin can add new services, manage all orders, maintain users’ roles. ',
    live: 'https://phassignment11.netlify.app/',
    github: 'https://github.com/yeasin-hossain/growdFood-client',
  },
  {
    id: 2,
    type: 'fullStack',
    screenshot: 'https://i.ibb.co/grKTrRX/mirpur.png',
    name: 'Mirpur Grocery Needs',
    technologies: ['React', 'Firebase Authentication', 'Express', 'MongoDB', 'Heroku', 'Netlify'],
    desc: '* In home page show all item, and if user login then can order the product. *Order route show, all orders information, only google login user can visit. *Admin page for add new product, remove the old product, and manage orders.',
    live: 'https://phassignment10.netlify.app/',
    github: 'https://github.com/yeasin-hossain/MirpurGroceryClient',
  },
  {
    id: 3,
    type: 'fullStack',
    screenshot: 'https://i.ibb.co/D5CHcwg/msg.png',
    name: 'Secret Message',
    technologies: [
      ' React',
      'Ant Design',
      'Express',
      'MongoDB',
      'Socket',
      'JWT',
      'Bcrypt',
      'Heroku',
      'Netlify',
    ],
    desc: '* Create a new account for receiving messages, if the user name not available show a warning. after creating an account share the URL with friends. *For sending a message don’t need an account, only visit the profile URL and Send a message to a friend. But the user can’t notice who sends a message. * Users can select its disposal or not. If disposal then selects a time, after period time message will delete automatically. ',
    live: 'https://shanto-message.netlify.app/shantoxdp',
    github: 'https://github.com/yeasin-hossain/secret-message-client',
  },
];
export const presentWork = [
  {
    name: 'EcoSoftBD Ltd.',
    logo: ecoSoftLogo,
    role: 'Software Engineer',
    date: 'Jan 2022 to Present',
    desc: 'Leading stock market solution provider/Finctech in Bangladesh (Online Share Trading, Smarter Stock, OMS, Back office software)',
  },
];
export const experience = [
  {
    id: 3,
    name: 'Strativ AB',
    logo: 'https://avatars.githubusercontent.com/u/67539095?s=200&v=4',
    role: 'Software Engineer(M1)',
    date: 'Aug 2022 to Feb 2023',
    desc: 'Develop real time Mobile app, Web application and maintain legacy project.',
    headerColor: '#E95A0C',
  },
  {
    id: 2,
    name: 'Softify Digital',
    logo: 'https://avatars.githubusercontent.com/u/77274477?v=4',
    role: 'Mobile Application Developer',
    date: 'June 2021 to Present(Part-Time)',
    desc: '*Develope Application For Android And IOS',
    headerColor: '#02018D',
  },
  {
    id: 1,
    name: 'HappyDesk',
    logo: 'https://avatars.githubusercontent.com/u/51847883?s=200&v=4',
    role: 'Frontend Developer',
    date: 'Feb 2021 to June 2021',
    desc: ' *UI Develop From sketch *Handle Functional Component *API Integration *Handle Auth (Firebase, JWT)',
    headerColor: '#E64E20',
  },
];
export const blog = [
  {
    id: 1,
    author: 'Abdullah Al Shahariar',
    title: 'রিয়েক্ট useCallback এবং useMemo হুক',
    image: 'https://miro.medium.com/max/875/1*KdFb2s56gkp5veAA58WuFA.jpeg',
    desc: 'আমরা জানি React.js হলো একটি কম্পোনেন্ট ওরিয়েন্টেড জাভাস্ক্রিপ্ট লাইব্রেরি। আর এটাও জানি React.js এ কোনো কম্পোনেন্ট এ যখন তার কোনো Stateএর ভ্যালু পরিবর্তন হয় তখনই একবার করে পুরো কম্পোনেন্টটি এবং এর মধ্যে থাকা চাইল্ড কম্পোনেন্টগুলো সহ রেন্ডার হয়',
    topics: 'react, hooks, useState',
    link: 'https://medium.com/%E0%A6%AA%E0%A7%8D%E0%A6%B0%E0%A7%8B%E0%A6%97%E0%A7%8D%E0%A6%B0%E0%A6%BE%E0%A6%AE%E0%A6%BF%E0%A6%82-%E0%A6%AA%E0%A6%BE%E0%A6%A4%E0%A6%BE/%E0%A6%B0%E0%A6%BF%E0%A7%9F%E0%A7%87%E0%A6%95%E0%A7%8D%E0%A6%9F-usecallback-%E0%A6%8F%E0%A6%AC%E0%A6%82-usememo-%E0%A6%B9%E0%A7%81%E0%A6%95-%E0%A6%AA%E0%A6%B0%E0%A7%8D%E0%A6%AC-%E0%A7%A7-48b81885141f',
  },
  {
    id: 2,
    author: 'Zonayed Ahmed',
    title: 'জাভাস্ক্রিপ্টঃ কোথায় এবং কিভাবে ইউজ করা হয়?',
    image: 'https://miro.medium.com/max/1250/1*L-UKP7ooUzP1U8796MxeTg.jpeg',
    desc: 'জাভাস্ক্রিপ্ট এ বিশাল লাইব্রেরী আর ফ্রেমওয়ার্ক এর সমাহার থাকায় সব ধরনের কাজই করা যায় এর মাধ্যমে। প্রধানত দুইভাবে জাভাস্ক্রিপ্ট কে ওয়েবে ইউজ করা হয়ঃ১। ক্লাইন্ট সাইডঃ শুধুমাত্র ব্রাউজারে চলে',
    topics: 'Javascript, browser',
    link: 'https://medium.com/%E0%A6%AA%E0%A7%8D%E0%A6%B0%E0%A7%8B%E0%A6%97%E0%A7%8D%E0%A6%B0%E0%A6%BE%E0%A6%AE%E0%A6%BF%E0%A6%82-%E0%A6%AA%E0%A6%BE%E0%A6%A4%E0%A6%BE/%E0%A6%9C%E0%A6%BE%E0%A6%AD%E0%A6%BE%E0%A6%B8%E0%A7%8D%E0%A6%95%E0%A7%8D%E0%A6%B0%E0%A6%BF%E0%A6%AA%E0%A7%8D%E0%A6%9F%E0%A6%83-%E0%A6%95%E0%A7%8B%E0%A6%A5%E0%A6%BE%E0%A7%9F-%E0%A6%8F%E0%A6%AC%E0%A6%82-%E0%A6%95%E0%A6%BF%E0%A6%AD%E0%A6%BE%E0%A6%AC%E0%A7%87-%E0%A6%87%E0%A6%89%E0%A6%9C-%E0%A6%95%E0%A6%B0%E0%A6%BE-%E0%A6%B9%E0%A7%9F-5cf729ab1cde',
  },
  {
    id: 3,
    author: 'Yeasin Hossain',
    title: 'Javascript encyclopedia',
    image: 'https://miro.medium.com/max/3000/1*3xHe8hXIDjWOSEYimM4MDA.gif',
    desc: 'try, catch JavaScript Try Catch Exception Example. The try statement lets you test a block of code for errors. The catch statement lets you handle the error.',
    topics: 'Javascript, Try-catch',
    link: 'https://yeasinxdp.medium.com/javascript-encyclopedia-5cff2d6ff003',
  },
  {
    id: 4,
    author: 'Yeasin Hossain',
    title: 'ES6 Array Magic',
    image:
      'https://res.cloudinary.com/practicaldev/image/fetch/s--ICM7iMAe--/c_imagga_scale,f_auto,fl_progressive,h_420,q_auto,w_1000/https://dev-to-uploads.s3.amazonaws.com/uploads/articles/hffdx3ycvug9wsgkby5c.png',
    desc: 'Today we learn about javascript es6 array features. If you want to work with an array map will help a lot. Imagine you have a ton of objects array. And you have rendered on the name object from array objects. Look at how I use the map function.',
    topics: 'Javascript, Array, Map, Filter',
    link: 'https://yeasinxdp.medium.com/es6-array-magic-35637a95acd0',
  },
  {
    id: 4,
    author: 'Yeasin Hossain',
    title: 'Javascript Array Mission',
    image: 'https://i.ibb.co/DWcGrBz/Capture.png',
    desc: 'Today we lean javascript array an array is a data structure. where we can store our data organized. array basically two types, one dimensional and multidimensional. most of the case we use one-dimensional array.',
    topics: 'Javascript, Array',
    link: 'https://yeasinxdp.medium.com/javascript-array-mission-3da4d17a0e66',
  },
];
